import { ControlType, FetchStatus } from "../../../base/types";
import { ErrorMessage, Spinner } from "../../../widgets";
import { QRScannerProperties, useQRScannerProperties } from "./QRScannerProperties";

import { DraftQRScannerComponent } from "./DraftQRScannerComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { QRScanner } from "./QRScanner";
import { Registry } from "../../../base/register";

const useQueryParams = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const referenceNo = queryParameters.get("id") || undefined;
    const date = queryParameters.get("d") || undefined;

    return { referenceNo, date }
}

export const QRScannerComponent: FC<IControlAttributes> = ({
    className, props
}) => {
    const { referenceNo, date } = useQueryParams()
    const { status, properties, error } = useQRScannerProperties(props)

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <QRScanner {...properties}
            referenceNo={referenceNo}
            date={date}
            className={className} />
    </>
}

Registry.addControl({
    id: "7585ffb6-25f4-43fa-877c-504fad12a2e3",
    name: "QR Scanner",
    type: ControlType.QRScanner,
    properties: QRScannerProperties,
    component: QRScannerComponent,
    draftComponent: DraftQRScannerComponent
})
